import { CHANGE_DISPLAY_LANGUAGE, SET_AUTHENTICATION_METHOD, SET_CSRF, } from '../actions/';
import { getExpirationTimestamp } from '../utils/getOAuthToken';
/**
 * Initialize deviceId at Redux store creation time to avoid stale window references on SSR requests
 * @param {string} sessionId
 * @returns {string}
 */
function getDeviceId(sessionId) {
    var _a, _b, _c, _d, _e;
    return (_d = (_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.amznMusic) === null || _b === void 0 ? void 0 : _b.appConfig) === null || _c === void 0 ? void 0 : _c.deviceId, (_d !== null && _d !== void 0 ? _d : null)) || ((_e = document) === null || _e === void 0 ? void 0 : _e.cookie.replace(/(?:(?:^|.*;\s*)ubid-main\s*\=\s*([^;]*).*$)|^.*$/, '$1').replace(/-/gi, '')) ||
        sessionId;
}
/**
 * Initialize sessionId at Redux store creation time to avoid stale window references on SSR requests
 * @returns {string}
 */
function getSessionId() {
    var _a, _b, _c, _d, _e;
    return (_d = (_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.amznMusic) === null || _b === void 0 ? void 0 : _b.appConfig) === null || _c === void 0 ? void 0 : _c.sessionId, (_d !== null && _d !== void 0 ? _d : null)) || ((_e = document) === null || _e === void 0 ? void 0 : _e.cookie.replace(/(?:(?:^|.*;\s*)session-id\s*\=\s*([^;]*).*$)|^.*$/, '$1'));
}
/**
 * Initialize authentication state at Redux store creation time to avoid stale window references on SSR requests
 * @returns {IAuthenticationState}
 */
export function getInitialState() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    const sessionId = getSessionId();
    return {
        accessToken: ((_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.amznMusic) === null || _b === void 0 ? void 0 : _b.appConfig) === null || _c === void 0 ? void 0 : _c.accessToken) || process.env.accessToken,
        customerId: ((_f = (_e = (_d = window) === null || _d === void 0 ? void 0 : _d.amznMusic) === null || _e === void 0 ? void 0 : _e.appConfig) === null || _f === void 0 ? void 0 : _f.customerId) || process.env.customerId,
        deviceId: getDeviceId(sessionId),
        sessionId,
        // @ts-ignore
        displayLanguageId: (_j = (_h = (_g = window) === null || _g === void 0 ? void 0 : _g.amznMusic) === null || _h === void 0 ? void 0 : _h.appConfig) === null || _j === void 0 ? void 0 : _j.displayLanguage,
        deviceType: ((_m = (_l = (_k = window) === null || _k === void 0 ? void 0 : _k.amznMusic) === null || _l === void 0 ? void 0 : _l.appConfig) === null || _m === void 0 ? void 0 : _m.deviceType) || process.env.deviceType || 'A16ZV8BU3SN1N3',
        marketplaceId: ((_q = (_p = (_o = window) === null || _o === void 0 ? void 0 : _o.amznMusic) === null || _p === void 0 ? void 0 : _p.appConfig) === null || _q === void 0 ? void 0 : _q.marketplaceId) || process.env.marketplaceId,
        expiresAt: getExpirationTimestamp(
        // @ts-ignore
        ((_t = (_s = (_r = window) === null || _r === void 0 ? void 0 : _r.amznMusic) === null || _s === void 0 ? void 0 : _s.appConfig) === null || _t === void 0 ? void 0 : _t.accessTokenExpiresIn) || process.env.expiresAt || 0),
        // @ts-ignore
        metricsContext: (_w = (_v = (_u = window) === null || _u === void 0 ? void 0 : _u.amznMusic) === null || _v === void 0 ? void 0 : _v.appConfig) === null || _w === void 0 ? void 0 : _w.metricsContext,
        csrf: (_z = (_y = (_x = window) === null || _x === void 0 ? void 0 : _x.amznMusic) === null || _y === void 0 ? void 0 : _y.appConfig) === null || _z === void 0 ? void 0 : _z.csrf,
        // @ts-ignore
        isCirrusAuthExpired: (_2 = (_1 = (_0 = window) === null || _0 === void 0 ? void 0 : _0.amznMusic) === null || _1 === void 0 ? void 0 : _1.appConfig) === null || _2 === void 0 ? void 0 : _2.isCirrusAuthExpired,
    };
}
;
function setAuthenticationMethod(state, action) {
    const { accessToken, expiresAt } = action.payload;
    return Object.assign(Object.assign({}, state), { accessToken, expiresAt });
}
export function AuthenticationReducer(state = getInitialState(), action) {
    var _a, _b;
    switch (action.type) {
        case SET_AUTHENTICATION_METHOD:
            return setAuthenticationMethod(state, action);
        case SET_CSRF:
            return Object.assign(Object.assign({}, state), { csrf: action.payload.csrf });
        case CHANGE_DISPLAY_LANGUAGE:
            document.documentElement.lang = (_b = (_a = action.payload.displayLanguageId) === null || _a === void 0 ? void 0 : _a.substring(0, 2), (_b !== null && _b !== void 0 ? _b : ''));
            return Object.assign(Object.assign({}, state), { displayLanguageId: action.payload.displayLanguageId });
        default:
            return state;
    }
}
